module.exports = __webpack_public_path__ + "img/kabum-cover.07c003e5.jpeg";